import React from "react";
// import Heading from "../Heading";
import { Box, Container, Typography } from "@mui/material";
// import GlobalSubHeading from "../GlobalSubHeading";
// import { getMeaning } from "../../utils/localization";
import { useInView } from "framer-motion";
import img from "../../assets/images/Products/CircularCompAnimation.svg";

import { motion, AnimatePresence } from "framer-motion";

const TailoredProducts = () => {
  const { ref, inView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  // Animation variants for cards
  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        delay: index * 0.15, // Staggered delay for each card
        ease: "easeOut",
      },
    }),
  };
  return (
    // <Box sx={TailoredStyles.mainbannerBox}>
    <Box sx={Styles.mainbannerBox}>
      <Container
        maxWidth="lg"
        disableGutters
        sx={{ py: 3 }}
        className="tailored-products-container"
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: { xs: "column", md: "row" },
            px: { md: 15, lg: 0 },
            // mt: { xs: "1.2rem", sm: "1.2rem", md: "1.2rem" },
            gap: 0,
          }}
        >
          <motion.div
            // custom={index}
            initial="hidden"
            animate="visible"
            variants={cardVariants}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Box mt={1}>
              <Typography
                variant="h3"
                // textAlign="left"
                sx={{
                  textAlign: { xs: "center", sm: "left" },
                  px: { xs: 4, sm: 0 },
                }}
                className="main-heading-font-size"
              >
                Tailor Made Products
              </Typography>
            </Box>
            <Box
              align="center"
              sx={{ px: { md: 15, lg: 0 }, maxWidth: 500 }}
              textSx={{ textAlign: "" }}
            >
              <Typography
                variant="h6"
                textAlign="justify"
                fontFamily="'Gilroy', sans-serif"
                sx={{
                  px: { xs: 4, sm: 0 },
                }}
              >
                We offer a diverse suite of assurance products tailored to
                seamlessly fit your business needs, no matter the industry. From
                cost-effective sachet offerings to comprehensive solutions, our
                product combos are designed to enhance your value proposition
                and meet your customers' needs.
              </Typography>
            </Box>
          </motion.div>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              my: 4,
              maxWidth: 600,
            }}
          >
            <Box
              component="img"
              alt=""
              src={img}
              sx={{
                width: {
                  xs: "75%", // Mobile
                  sm: "45%", // Small tablets
                  md: "70%", // Medium devices
                  lg: "75%", // Large desktops
                  xl: "80%", // Extra large screens
                },
                // width: {
                //   xs: "75%", // Mobile
                //   sm: "45%", // Small tablets
                //   md: "35%", // Medium devices
                //   lg: "30%", // Large desktops
                //   xl: "35%", // Extra large screens
                // },
                maxWidth: "100%",
                height: "auto",
                display: "block",
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default TailoredProducts;

const Styles = {
  mainbannerBox: {
    textAlign: "center",
  },
};
